import type { UUID } from "../../utils/uuid";

export interface CustomDashboardConfig {
  id: UUID;
  enabled: boolean;
  /** The dashboard's slug in our Luzmo integration. */
  slug: string;
  tabName: string;
}

export interface EditableCustomDashboardConfig {
  id: UUID | null;
  enabled: boolean;
  slug: string;
  tabName: string;
}

export interface StoredCustomDashboardConfig {
  id: UUID;
  enabled: boolean;
  /** Holds the dashboard slug. */
  url: string;
  tab_name: string;
}

export const toCustomDashboardConfig = ({
  id,
  enabled,
  url,
  tab_name,
}: StoredCustomDashboardConfig): CustomDashboardConfig => ({
  id,
  enabled,
  slug: url.trim(),
  tabName: tab_name.trim(),
});

export const isValidDashboardSlug = (value: string): boolean => /^[\w-]+$/.test(value);

export const visibleCustomDashboardConfigs = (
  dashboards: StoredCustomDashboardConfig[],
): CustomDashboardConfig[] =>
  dashboards.flatMap((dashboard) => {
    const config = toCustomDashboardConfig(dashboard);
    return config.enabled && config.tabName && isValidDashboardSlug(config.slug) ? [config] : [];
  });
